export default {"src":"/_next/static/media/ALGN.6d591967.svg","height":18,"width":18};